import styled, { css } from 'styled-components';
import { rgba } from 'polished';

// CONSTANTS
import colors, {
  MAIN_BLACK,
  RADICAL_RED,
  GRAY_SUIT,
  ATHENS_GRAY,
  SANTAS_GRAY,
} from '@/constants/colors';

import { breakpoints } from '@/utility/breakpoints';

const { appCard } = colors;

export const AppCardContainer = styled.div`
  width: 100%;
  position: relative;
  padding: 6px 14px 16px;

  display: flex;
  flex-direction: column;

  background-color: ${appCard.bg};
  border-radius: 8px;

  ${p =>
    p.withShadow &&
    css`
      box-shadow: 0 8px 16px ${rgba(MAIN_BLACK, 0.1)};
      transition: box-shadow 0.4s;

      &:hover {
        box-shadow: 0 16px 32px ${rgba(MAIN_BLACK, 0.1)};
      }
    `}

  a:not(.MuiButton-root) {
    display: block;
    width: 100%;
    color: inherit;
    text-decoration: none;
  }

  &.app-card,
  .app-card {
    position: relative;

    &--full-height {
      height: 100%;
    }

    &__markers {
      position: absolute;
      top: -15px;
      left: -15px;
    }

    &__logo-wrapper {
      padding-top: 30px;
    }

    &__logo {
      display: flex;
      justify-content: center;
      align-items: center;
      border-bottom: 1px solid ${ATHENS_GRAY};
      height: 90px;

      img {
        max-height: 90px;
      }

      img {
        max-width: 100%;
        max-height: 90px;
      }
    }

    &__title {
      min-height: 2.2rem;
      margin-bottom: 4px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }

    &__deal-price {
      display: flex;
      flex-direction: column;
      align-items: center;
    }

    &__cost {
      flex: 1;
      display: flex;
      justify-content: center;
      align-items: center;
      color: ${appCard.cost};

      &--current {
        font-weight: bold;
      }

      &--deal {
        position: relative;

        &:before {
          content: '';
          position: absolute;
          right: -3px;
          left: -3px;
          top: 50%;
          transform: translate(0, -50%);
          height: 1px;
          background-color: ${RADICAL_RED};
        }
      }

      svg {
        cursor: pointer;
        margin-left: 5px;
        font-size: 16px;
      }
    }

    &__button {
      margin-top: 8px;
    }

    &__icon-btn {
      top: 6px;
      padding: 0;
      position: absolute;

      .MuiSvgIcon-root,
      .MuiIcon-root {
        font-size: 2.7rem;
      }

      .more-icon {
        color: ${SANTAS_GRAY};
      }

      .remove-icon {
        color: ${GRAY_SUIT};
        font-size: 2.4rem;
      }

      .mb-icon {
        width: 1em;
        height: 1em;
      }
    }

    &__right-btn {
      right: 13px;
    }

    &__left-btn {
      left: 13px;
    }

    &__link-wrapper {
      .app-card__logo {
      }

      .app-card__title {
        margin-top: 8px;
      }
    }
  }

  ${breakpoints.up('sm')} {
    padding: 13px 13px 16px;

    &.app-card,
    .app-card {
      &__icon-btn {
        top: 13px;
      }

      &__logo-wrapper {
        padding-top: 35px;
      }

      &__logo {
        height: 125px;

        img {
          max-height: 125px;
        }
      }

      &__title {
        margin-bottom: 8px;
        text-align: left;
      }

      &__cost {
        justify-content: flex-start;

        &--current {
          font-weight: inherit;
        }
      }

      &__price {
        color: ${MAIN_BLACK};
      }
    }
  }
`;

export default AppCardContainer;
